SharedSpinnerTemplate = require('../../spinner.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $

class SharedSpinnerView extends Backbone.View

  initialize : ->
    @I18nScope = 'modules.shared'
    @template = SharedSpinnerTemplate

  show : (hash) ->
    if hash?.container?
      @$container = hash.container
      @$el.html toHtml(@template, hash, @I18nScope)

      if hash.append
        @$container.append @$el
      else
        @$container.html @$el

      if hash.height
        @$el.css('height', hash.height)
        $('.g-spinner', @$el).css('height', hash.height)
      if hash.id
        @$el.attr('id', hash.id)


  hide : () ->
    @$el.empty()

  remove : () ->
    @$el.remove()

module.exports = SharedSpinnerView
